const css = `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.education-card {
  display: flex;
  flex-direction: row;
}

.education-card:hover + .education-card-border {
  border-color: #a9a7f9;
  width: 100%;
  -webkit-transition: width 0.6s ease-in-out;
  -moz-transition: width 0.6s ease-in-out;
  -o-transition: width 0.6s ease-in-out;
  transition: width 0.6s ease-in-out;
}

.education-card-border {
  height: 30px;
  width: 80%;
  border-top: 2px solid rgba(211, 211, 211, 0.397);
  margin-bottom: 20px;
  -webkit-transition: width 0.6s ease-in-out;
  -moz-transition: width 0.6s ease-in-out;
  -o-transition: width 0.6s ease-in-out;
  transition: width 0.6s ease-in-out;
}

.education-head {
  display: flex;
  flex-direction: row;
}

.education-text-school {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 27px;
}

.education-roundedimg {
  object-fit: cover;
  margin-right: 2rem;
  width: 6rem;
  height: 6rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  border-radius: 50%;
}

.education-card-right {
  max-width: 70%;
}

.education-text-subHeader {
  color: #000000;
  font-weight: 700;
  font-size: 19px;
  margin: 0px;
  padding-top: 0.8rem;
  line-height: normal;
}

.education-text-duration {
  color: #000000;
  font-size: 19px;
  margin: 0px;
  padding-top: 0.5rem;
}

.education-text-desc {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.education-text-bullets > ul {
  margin-top: 0.5rem;
}

/* Media Query */
@media (max-width: 1380px) {
  .education-card {
    flex-direction: column;
    padding-bottom: 10px;
  }
  .education-card-right {
    max-width: 90%;
  }
  .education-card-border {
    width: 90%;
  }
  .education-text-subHeader {
    padding-top: 0.5rem;
    font-size: 16px;
  }
  .education-text-school {
    font-size: 20px;
    height: 23px;
  }
  .education-text-duration {
    font-size: 16px;
  }
  .education-roundedimg {
    width: 4rem;
    height: 4rem;
    margin-bottom: 0.5rem;
    margin-right: 0px;
  }
}
@media (max-width: 768px) {
  .education-card {
    text-align: center;
  }
  .education-card-right {
    max-width: 100%;
  }
  .education-card-border {
    width: 100%;
  }
  .education-roundedimg {
    margin-top: 10px;
    width: 4rem;
    height: 4rem;
    margin-bottom: 1rem;
    margin-right: 0;
  }
  .education-text-bullets > ul {
    max-width: 80%;
    margin: auto;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
